import React from 'react'
import { SVGIconProps } from '../types'
const SvgViewComfy = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M3 9h4V5H3zm0 5h4v-4H3zm5 0h4v-4H8zm5 0h4v-4h-4zM8 9h4V5H8zm5-4v4h4V5zm5 9h4v-4h-4zM3 19h4v-4H3zm5 0h4v-4H8zm5 0h4v-4h-4zm5 0h4v-4h-4zm0-14v4h4V5z" />
  </svg>
)
export default SvgViewComfy
